import { createApp } from "vue";
import * as Sentry from "../../sentry/sentry.js";
import App from "./App.vue";
import * as Nav from "./navigation.js";
import router from "./router.js";
import { routes } from "./routes.js";
import "./tailwind.css";
import EmptyLayout from "./components/EmptyLayout.vue";

const app = createApp(App);
Sentry.init(app, router);
app.component("empty-layout", EmptyLayout);
app.use(router);
// NOTE: used to have "remove leftover route" code here. Not required now that app1 usings path-routes

Nav.init(routes); // fix annoying cyclic dependencies
app.mount("#app");
// console.log("app mounted");
